import styled from 'styled-components';
import { Typography } from '../../display/Typography';

export const GeneralContainer = styled.form`
  width: 100%;
  padding: ${({ theme }) => theme.spaces.xl}rem;
  border-radius: 0.8rem;
  background-color: ${({ theme }) =>
    theme.colors.backgroundLila};
`;

export const Title = styled(Typography)`
  margin: 0 0 3.2rem;
`;

export const RowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.l}rem;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.l}rem;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-wrap: wrap;
  }
`;

export const AdviceContainer = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spaces.s}rem
    ${({ theme }) => theme.spaces.l}rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.greyDark};
  /* "max-content" mide el texto en UNA sola línea y no tiene tope: en una
     tarjeta estrecha la caja se salía por la derecha en vez de partir el
     texto (medido: 512 px de caja dentro de una tarjeta de 420 px). El
     "max-width" le pone el techo del padre, así que envuelve a varias
     líneas y deja de desbordar. */
  width: max-content;
  max-width: 100%;
  margin: 0 auto;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 4rem;
  gap: 1rem;
`;

export const TitleContainerWithButton = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spaces.l}rem;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spaces.m}rem;
`;

export const ContainerError = styled.div`
  padding-top: ${({ theme }) => theme.spaces.s}rem;
`;

/**
 * Hueco de tamaño FIJO para el indicador de carga que sustituye al botón «+»
 * mientras se comprimen fotos.
 *
 * Sin esto la fila se estiraba al añadir (feedback tablet 2026-08-15): el
 * `ButtonIconBackground` mide 3,4 rem y el Loader canónico mide 5 rem, trae
 * `margin: auto` —que dentro de un flex absorbe el espacio libre— y una sombra
 * absoluta a 6 rem. Reservando el mismo hueco que el botón, la lista solo
 * cambia de alto cuando de verdad entra una foto nueva.
 */
export const InlineLoaderSlot = styled.div`
  width: 3.4rem;
  height: 3.4rem;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  & > [role='progressbar'] {
    margin: 0;
    /* 🔴 Sin "flex: 0 0 auto" el hijo se ESTRUJA: por defecto un item de flex
       lleva "flex-shrink: 1", así que sus 5 rem de ANCHO se reducían al hueco
       de 3,4 rem mientras el ALTO seguía a 5 rem — dejaba de ser cuadrado.
       Con esto conserva su tamaño y solo lo reduce el "scale", que sí es
       proporcional: 5 rem × 0,68 = 3,4 rem, el mismo hueco que el botón. */
    flex: 0 0 auto;
    transform: scale(0.68);
  }
`;
